import { makeStyles } from '@material-ui/core/styles';
import rci from '../../img/stock-photo.jpg';
import asha from '../../img/ASHA-image.jpg';
import ahrq from '../../img/AHRQ-image.jpg';
import ahrq2 from '../../img/AHRQ-2-image.jpg';
import bio1 from '../../img/team-photo1.jpg';


const studyClasses = makeStyles((theme) => ({
  bioImage1: {
    backgroundImage:`url(${bio1})`,
    backgroundRepeat: 'no-repeat',
    backgroundColor:
    theme.palette.type === 'light' ? theme.palette.grey[50] : theme.palette.grey[900],
    backgroundSize: 'cover',
    backgroundPosition: 'center',
    display: 'flex',
    borderRadius: 30,
    minHeight: 500,
  }, 
  whiteBox: {
    backgroundColor: '#ffffff',
    color: '#555263',
    borderRadius: 20,
    padding: 50,
    [theme.breakpoints.down('md')]: {
      padding: 25,
    },
  },
    listPadding: {
    paddingRight: 20,
    [theme.breakpoints.down('md')]: {
      paddingRight: 0,
    },
  },
  buttonImageGallery: {
    padding: 0, 
    lineHeight: 0, 
    borderRadius: 20,
    marginBottom: 20,
  },
  rciImg: {
    backgroundImage:`url(${rci})`,
    backgroundRepeat: 'no-repeat',
    backgroundColor:
    theme.palette.type === 'light' ? theme.palette.grey[50] : theme.palette.grey[900],
    backgroundSize: 'cover',
    backgroundPosition: 'center',
    minHeight:300,
    borderRadius: 30,
  },
  ahrqImg: {
    backgroundImage:`url(${ahrq})`,
    backgroundRepeat: 'no-repeat',
    backgroundColor:
    theme.palette.type === 'light' ? theme.palette.grey[50] : theme.palette.grey[900],
    backgroundSize: 'cover',
    backgroundPosition: 'center',
    minHeight:300,
    borderRadius: 30,
  },
  ahrqImg2: {
    backgroundImage:`url(${ahrq2})`,
    backgroundRepeat: 'no-repeat',
    backgroundColor:
    theme.palette.type === 'light' ? theme.palette.grey[50] : theme.palette.grey[900],
    backgroundSize: 'cover',
    backgroundPosition: 'center',
    minHeight:300,
    borderRadius: 30,
  },
  ashaImg: {
    backgroundImage:`url(${asha})`,
    backgroundRepeat: 'no-repeat',
    backgroundColor:
    theme.palette.type === 'light' ? theme.palette.grey[50] : theme.palette.grey[900],
    backgroundSize: 'cover',
    backgroundPosition: 'center',
    minHeight:300,
    borderRadius: 30,
  },
  imageGallery: {
    width: '100%',
    borderRadius: 20,
  },
  }));
  export default studyClasses